import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import IcShieldReportRegular from 'src/assets/images/icShieldReportRegular.svg';
import IcTrashRegular from 'src/assets/images/icTrashRegular.svg';
import { hoverAndActiveCss } from 'src/utils/styled';
interface Props {
  onReport: () => void;
  onDelete: () => void;
  onClose?: () => void;
}
const Root = styled.ul`
  list-style: none;
  margin: 0;
  padding: 8px;
  width: 210px;
  border-radius: 8px;
  background-color: ${({
  theme
}) => theme.color.surface4};
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.25);

  ${({
  theme
}) => theme.screenSize.mobile} {
    width: 100%;
    padding: 16px 0;
    padding-bottom: calc(16px + var(--sab));
    border-radius: 20px 20px 0 0;
    background-color: ${({
  theme
}) => theme.color.bg2};
  }
`;
const Item = styled.li`
  list-style: none;
`;
const MenuButton = styled.button`
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${({
  theme
}) => theme.color.content12};

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }

  ${({
  theme
}) => hoverAndActiveCss(`
      background-color: ${theme.color.surface5};
      border-radius: 8px;
    `)}
`;
const MenuIcon = styled.div`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
    color: inherit;
  }
`;
export default function InviteUserMoreMenu({
  onReport,
  onDelete,
  onClose
}: Props) {
  const {
    t
  } = useTranslation('translations');
  const handleReport = () => {
    onReport();
    onClose?.();
  };
  const handleDelete = () => {
    onDelete();
    onClose?.();
  };
  return <Root data-sentry-element="Root" data-sentry-component="InviteUserMoreMenu" data-sentry-source-file="InviteUserMoreMenu.tsx">
      <Item data-sentry-element="Item" data-sentry-source-file="InviteUserMoreMenu.tsx">
        <MenuButton onClick={handleReport} data-testid='InviteUserMoreMenu-report' data-sentry-element="MenuButton" data-sentry-source-file="InviteUserMoreMenu.tsx">
          <MenuIcon data-sentry-element="MenuIcon" data-sentry-source-file="InviteUserMoreMenu.tsx">
            <IcShieldReportRegular aria-hidden data-sentry-element="IcShieldReportRegular" data-sentry-source-file="InviteUserMoreMenu.tsx" />
          </MenuIcon>
          {t('BUTTON__REPORT')}
        </MenuButton>
      </Item>
      <Item data-sentry-element="Item" data-sentry-source-file="InviteUserMoreMenu.tsx">
        <MenuButton onClick={handleDelete} data-testid='InviteUserMoreMenu-delete' data-sentry-element="MenuButton" data-sentry-source-file="InviteUserMoreMenu.tsx">
          <MenuIcon data-sentry-element="MenuIcon" data-sentry-source-file="InviteUserMoreMenu.tsx">
            <IcTrashRegular aria-hidden data-sentry-element="IcTrashRegular" data-sentry-source-file="InviteUserMoreMenu.tsx" />
          </MenuIcon>
          {t('COMMON.DELETE')}
        </MenuButton>
      </Item>
    </Root>;
}